import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';

export const Input = styled.input`
  height: 48px;
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid ${Colors.whisper};
  font-size: 16px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  padding-left: 10px;
  padding-right: 10px;
`;
